<rtc-detached-router-outlet />
